import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/cirk.styles.css";

export const CIRK = () => {
	return <SubserviceWrapper config={services.circlek} />;
};
